import React from 'react';

export default class Header extends React.Component {
    render() {
        return (
            <header id="header">
                <nav>
                    <ul>
                        <li><a href="#menu">Menu</a></li>
                    </ul>
                </nav>
            </header>
        );
    }
}
